import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "dialog-footer" }
const _hoisted_2 = ["src"]

import {Plus} from "@element-plus/icons-vue";
import axios from "axios";
import {ref} from "vue";
import {UploadInstance, UploadProps} from "element-plus/es";
import {useStore} from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'DataUpload',
  emits: ['updateFileList'],
  setup(__props, { emit: emits }) {


const store = useStore();
const uploadShow = ref(false);
const uploadFileList = ref([]);
const uploadRef = ref<UploadInstance>();
const dialogImageUrl = ref("");
const dialogVisible = ref(false);

const handleRemove: UploadProps["onRemove"] = (uploadFile, uploadFiles) => {
  // console.log(uploadFileList);
  // const index=uploadFileList.value.findIndex((e)=>{return e===uploadFile})
  console.log(uploadFile, uploadFiles);
};
const handlePictureCardPreview: UploadProps["onPreview"] = (uploadFile) => {
  dialogImageUrl.value = uploadFile.url!;
  dialogVisible.value = true;
  // console.log("dialogImageUrl.value: ", dialogImageUrl.value)
};
const handleChange: UploadProps["onChange"] = (file, fileList) => {
  uploadFileList.value = fileList;
};
async function submitUpload(){
  let param = new FormData();
  console.log(uploadFileList);
  uploadFileList.value.forEach(
      (val, index) => {
        param.append("pictures", val.raw);
        console.log("test", val.raw);
      }
  );
  console.log("datasetId: ", store.state.datasetId);
  param.append("datasetId", store.state.datasetId);
  let config = {
    baseURL: "/api",
    //baseURL: "http://localhost:7996",
    timeout: 30000,
    headers: {
      "Content-Type": "multipart/form-data" //设置headers
    }
  };
  console.log("param", param);
  await axios
      .post("/data/uploadPictures", param, config)
      .then(res => {
        console.log(res);
        if (res.status === 200) {
          console.log("yes");
          uploadRef.value.clearFiles();
        }
      })
      .catch(err => {
        console.log(err);
      });
  console.log(uploadFileList);
  emits('updateFileList','getDatasetInfo')
  uploadShow.value = false;
  // fileList= fileList.concat(file)
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_backtop = _resolveComponent("el-backtop")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_button, {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (uploadShow.value=true)),
      type: "primary"
    }, {
      default: _withCtx(() => [
        _createTextVNode("上传图片")
      ]),
      _: 1
    }),
    _createVNode(_component_el_dialog, {
      modelValue: uploadShow.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((uploadShow).value = $event))
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, [
          _createVNode(_component_el_button, {
            onClick: _cache[1] || (_cache[1] = ($event: any) => (uploadShow.value = false))
          }, {
            default: _withCtx(() => [
              _createTextVNode("取消")
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: submitUpload
          }, {
            default: _withCtx(() => [
              _createTextVNode("确定")
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_upload, {
          ref_key: "uploadRef",
          ref: uploadRef,
          method: "post",
          action: "#",
          "list-type": "picture-card",
          "on-preview": handlePictureCardPreview,
          "on-remove": handleRemove,
          "on-change": handleChange,
          "auto-upload": false,
          multiple: "",
          "show-file-list": "",
          "file-list": uploadFileList.value
        }, {
          trigger: _withCtx(() => [
            _createVNode(_component_el_icon, null, {
              default: _withCtx(() => [
                _createVNode(_unref(Plus))
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["file-list"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((dialogVisible).value = $event))
    }, {
      default: _withCtx(() => [
        _createElementVNode("img", {
          src: dialogImageUrl.value,
          alt: "Preview Image"
        }, null, 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_backtop, {
      right: 100,
      bottom: 100
    })
  ], 64))
}
}

})